import styled from 'styled-components';
import { Button } from '../../components/Button';
import { PageTitle } from '../../components/PageTitle';
import { FontWeight } from '../../constants/Styles/fontWeight';
import { units } from '../../helpers/styles/units';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(20)};
  padding-left: ${units(12)};
`;

export const StyledPageTitle = styled(PageTitle)`
  font-weight: ${FontWeight.MEDIUM};
`;

export const StyledSearchBarWrapper = styled.div`
  max-width: ${units(322)};
  flex: 1 1 auto;
`;

export const StyledButton = styled(Button)<{color?: string}>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${units(3)};
  max-width: ${units(107)};
  width: 100%;
  height: ${units(24)};
  color: ${({ color }) => color};
  border: 1px solid ${({ color }) => color};
`;

export const StyledFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
